<template>
  <div>
    <div class="flex">
      <div class="w-1/3">
        <mia-feature-toggle
          v-model="form.item_observe"
          label="Fahrzeug beobachten"
          label-position="top"
          :errors="getErrors('item_observe')"
          @input="clearErrors('item_observe')"
        />
      </div>
      <div class="w-2/3">
        <mia-feature-select
          v-model="form.item_assignee"
          label="Zuständig"
          :errors="getErrors('item_assignee')"
          @input="clearErrors('item_assignee')"
        >
          <template #options>
            <option value="">
              Zuständigkeit auswählen
            </option>
            <option
              v-for="employee in employees"
              :key="employee.id"
              :value="employee.id"
              :selected="employee.id === form.item_assignee"
            >
              {{ employee.full_name }}
            </option>
          </template>
        </mia-feature-select>
      </div>
    </div>

    <div class="flex justify-end mt-4">
      <mia-submit-button
        label="Speichern"
        :disabled="$wait.any"
        :is-loading="$wait.is('updating car settings')"
        type="button"
        @click="updateSettings"
      />
    </div>
  </div>
</template>

<script>
import { getCar } from '@/api/car'
import { updateSettings } from '@/api/cars'
import { getEmployees } from '@/api/dealer'
import FeatureSelect from '@/components/cars/edit/FeatureSelect.vue'
import FeatureToggle from '@/components/cars/edit/FeatureToggle.vue'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import HandlesBackendValidationErrors from '@/mixins/HandlesBackendValidationErrors'

export default {
  name: 'MiaCarEditSettings',

  components: {
    'mia-feature-select': FeatureSelect,
    'mia-feature-toggle': FeatureToggle,
    'mia-submit-button': SubmitButton
  },

  mixins: [HandlesBackendValidationErrors],

  data: () => ({
    employees: [],
    form: {
      item_observe: false,
      item_assignee: ''
    }
  }),

  computed: {
    car: {
      get() {
        return this.$store.state.car.car
      },

      set(car) {
        this.$store.commit('setCar', car)
      }
    }
  },

  watch: {
    car: {
      deep: true,
      immediate: true,
      handler(car) {
        this.form.item_observe = car.observe_count > 0
        this.form.item_assignee = parseInt(car.item_assignee, 10)
      }
    }
  },

  async created() {
    this.employees = await getEmployees()
  },

  methods: {
    async updateSettings() {
      this.$wait.start('updating car settings')

      const [errors] = await updateSettings(this.car.id, {
        item_assignee: this.form.item_assignee,
        item_observe: this.form.item_observe ? 'Y' : 'N'
      })

      this.$wait.end('updating car settings')

      if (errors) {
        this.handleBackendValidationErrors(errors)
        window.eventBus.$emit('mia-error', {
          error: ['Die Einstellungen konnten nicht aktualisiert werden.']
        })
        return
      }

      this.resetErrors()
      this.car = await getCar({
        carId: this.car.id
      })

      window.eventBus.$emit('mia-info', {
        info: ['Einstellungen wurden erfolgreich aktualisiert.']
      })
    }
  }
}
</script>
